import { Component, Input, OnInit } from '@angular/core';

// custom enums
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';

// custom services
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

@Component({
  selector: 'app-favourit-btn',
  templateUrl: './favourit-btn.component.html',
  styleUrls: ['./favourit-btn.component.scss']
})
export class FavouritBtnComponent implements OnInit {

  // inputs
  @Input('id') id: string | number
  @Input('state') state: boolean

  constructor(
    private G: GlobleService,
    private API_RESPONSE: ApiResponseService
  ) { }

  ngOnInit(): void {
  }

  ChangeStateFav(): void {

    if (this.G.CorrectUserId) {

      if (!this.state) {
        this.API_RESPONSE.AddToFavourites(this.id, { params: { [RANDOM_VALUE.loader]: true } })
        .subscribe((res: any) => {
  
          if (res) this.state = true
  
        })
      } 
      else {
        this.API_RESPONSE.RemoveFromFavourites(this.id, { params: { [RANDOM_VALUE.loader]: true } })
        .subscribe((res: any) => {
  
          if (res) this.state = false
  
        })
      }
      
    }

  }

}
